module.exports = __webpack_public_path__ + "img/dashboard-status-alt.2413426a.svg";